import { CHECKLIST_TOAST_SCOPE } from '@features/Checklist/model/consts';

export const getChecklistToastScope = (positionGuid: string) =>
    `${CHECKLIST_TOAST_SCOPE}:${positionGuid || 'default'}`;
